<template>
	<div class="destroy-phone">
		<HeaderVertical title="输入手机号"></HeaderVertical>

		<van-field
			class="input-phone"
			v-model="phone"
			type="tel"
			maxlength="11"
			placeholder="手机号"
		/>
		<div class="common-button btn" @click="handle_destroy">确认</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			phone: '',
		};
	},
    created () {
        this.verify_login()
    },
	methods: {
        // 校验登录
        verify_login () {
            const token = localStorage.getItem('token')
            if (!token) {
                this.$toast({
                    type: 'fail',
                    message: '请先登录',
                })
                setTimeout(() => {
                    this.$router.push({
                        name: 'invitation_login'
                    })
                }, 1000)
            }
        },

		// 校验手机号
		verify_mobile () {
			const val = this.phone;
			if (!val) return false;
			if (val.length !== 11) return false;

			const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
			if (!myreg.test(val)) return false;

			return true;
		},

        // 核销
        handle_destroy () {
            // 校验手机号
            if (!this.verify_mobile()) {
                return this.$toast({
                    type: 'fail',
                    message: '请输入正确的手机号',
                })
            }

            this.$router.push({
                name: 'hexiao',
                query: {
                    phone: this.phone,
                },
            })
        },
	},
};
</script>

<style lang="less" scoped>
@import './destroy_phone.less';
</style>
